// Juridical extensions patterns used to validate Mexican legal entity suffixes
export const JURIDICAL_EXTENSIONS_REGEX: RegExp[] = [
  /S\.?\s*A\.?$/i, // SA
  /S\.?\s*A\.?\s*DE\s*C\.?\s*V\.?$/i, // SA DE CV
  /S\.?\s*DE\s*R\.?\s*L\.?$/i, // S DE RL
  /S\.?\s*DE\s*R\.?\s*L\.?\s*DE\s*C\.?\s*V\.?$/i, // S DE RL DE CV
  /S\.?\s*P\.?\s*R\.?\s*DE\s*R\.?\s*L\.?\s*DE\s*C\.?\s*V\.?$/i, // SPR DE RL DE CV
  /S\.?\s*A\.?\s*P\.?\s*I\.?$/i, // SAPI
  /S\.?\s*A\.?\s*P\.?\s*I\.?\s*DE\s*C\.?\s*V\.?$/i, // SAPI DE CV
  /S\.?\s*C\.?$/i, // SC
  /A\.?\s*C\.?$/i, // AC
  /I\.?\s*A\.?\s*P\.?$/i, // IAP
  /S\.?\s*A\.?\s*S\.?$/i, // SAS
  /S\.?\s*A\.?\s*S\.?\s*DE\s*C\.?\s*V\.?$/i, // SAS DE CV
  /S\.?\s*EN\s*N\.?\s*C\.?$/i, // S EN NC
  /S\.?\s*EN\s*C\.?$/i, // S EN C
  /S\.?\s*EN\s*C\.?\s*POR\s*A\.?$/i, // S EN C POR A
  /S\.?\s*R\.?\s*L\.?\s*DE\s*C\.?\s*V\.?$/i, // SRL DE CV
];
